import { useAtomValue } from "jotai";
import { type FunctionComponent, Suspense } from "react";

import { accountAtom, logout } from "shared/lib/account";

import { HamburgerMenuWrapper } from "scmp-app/components/hamburger-menu/hamburger-menu-wrapper";
import type { Props as HamburgerMenuWrapperProps } from "scmp-app/components/hamburger-menu/hamburger-menu-wrapper";

import { useHomePageLink, useNewslettersPageLink, useStylePageLink } from "./hooks";
import {
  Container,
  Follow,
  FollowFacebookIcon,
  FollowInstagramIcon,
  FollowLinkGroup,
  FollowTitle,
  Footer,
  Header,
  LatestNews,
  Link,
  Logout,
  News,
  NewsHomeLink,
  Privacy,
  StayOnTrend,
  StayOnTrendButton,
  StayOnTrendSubTitle,
  StayOnTrendTitle,
  StyledCloseIcon,
  StyledLogoFlag,
  StyledLogoText,
  StyledScmpLogo,
  StyledTopStories,
  StyleHomeLink,
  Terms,
} from "./styles";

type Props = Pick<HamburgerMenuWrapperProps, "anchor">;

export const HamburgerMenuMagazinesStyle: FunctionComponent<Props> = ({ anchor }) => {
  const { isLoggedIn } = useAtomValue(accountAtom);
  const stylePageLink = useStylePageLink();
  const homePageLink = useHomePageLink();
  const newslettersPageLink = useNewslettersPageLink();

  return (
    <Suspense>
      <HamburgerMenuWrapper anchor={anchor} backdrop>
        {({ handleClose, handleCloseExplicit }) => (
          <Container>
            <Header>
              <StyleHomeLink {...stylePageLink} onNavigate={handleClose}>
                <StyledLogoFlag />
                <StyledLogoText />
              </StyleHomeLink>
              <StyledCloseIcon onClick={handleCloseExplicit} />
            </Header>
            <StyledTopStories onNavigate={handleClose} />
            <StayOnTrend>
              <StayOnTrendTitle>stay on trend</StayOnTrendTitle>
              <StayOnTrendSubTitle>
                Get the STYLE invite newsletter;
                <br />
                your guide to the A-lister lifestyle.
              </StayOnTrendSubTitle>
              <Link {...newslettersPageLink} onClick={handleClose}>
                <StayOnTrendButton>sign up now</StayOnTrendButton>
              </Link>
            </StayOnTrend>
            <Follow>
              <FollowTitle>follow us</FollowTitle>
              <FollowLinkGroup>
                <Link href="https://www.facebook.com/scmpstyle/" target="_blank">
                  <FollowFacebookIcon />
                </Link>
                <Link href="https://www.instagram.com/scmp_style/" target="_blank">
                  <FollowInstagramIcon />
                </Link>
              </FollowLinkGroup>
            </Follow>
            <News>
              <NewsHomeLink {...homePageLink} onNavigate={handleClose}>
                <StyledScmpLogo />
                <LatestNews>latest news</LatestNews>
              </NewsHomeLink>
            </News>
            <Footer>
              <Terms>
                <Link href="/terms-conditions" target="_blank">
                  terms & condition
                </Link>
              </Terms>
              <Privacy>
                <Link href="/privacy-policy" target="_blank">
                  privacy
                </Link>
              </Privacy>
              {isLoggedIn && (
                <Logout onClick={() => logout()}>
                  <Link>logout</Link>
                </Logout>
              )}
            </Footer>
          </Container>
        )}
      </HamburgerMenuWrapper>
    </Suspense>
  );
};
